import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { LimeBandCTA } from '../components/LimeBandCTA';
import ClientLogos from '../components/ClientLogos';
import { Link } from 'react-router-dom';
export function Home() {
  const [rotation, setRotation] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const rotationDegrees = scrollPosition * 0.2;
      setRotation(rotationDegrees);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-227" data-mp="29i7zi2lc86gn">
      <Navbar data-id="element-228" data-mp="2dii1l460ecq8" />
      <main className="flex-grow" data-id="element-229" data-mp="2dj1mmtqyhh8h">
        {/* Hero Section - Simple headline only */}
        <section className="pt-32 md:pt-48 pb-12 md:pb-20 bg-white" data-id="element-230" data-mp="3kuqvtaabdvjm">
          <div className="container mx-auto px-4 md:px-12" data-id="element-231" data-mp="3ow437ot226sn">
            <div className="max-w-4xl" data-id="element-232" data-mp="3oyq97k0ase8r">
              <h1 className="font-poppins font-normal text-3xl md:text-5xl text-black leading-tight" data-id="element-233" data-mp="30x1jeg8b2qr1">
                Change happens to people.
                <br data-id="element-234" data-mp="2vvlw0hino85h" />
                Progress happens through
                <br data-id="element-235" data-mp="2qxkei10vogw4" />
                people.
              </h1>
            </div>
          </div>
        </section>
        {/* Full Width Home Image 1 */}
        <div className="w-full aspect-[21/9] overflow-hidden" data-id="element-236" data-mp="2mzcyx9i5hlmi">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nXwaeoEQEZJFV4SYhibeRR/Home_Image_1.jpg" alt="Geometric architectural pattern with green and teal glass" className="w-full h-full object-cover" data-id="element-237" data-mp="2hzi3qtrce9vn" />
        </div>
        {/* Get in Touch CTA Band */}
        <LimeBandCTA linkText="Let's Connect" href="/contact" data-id="element-238" data-mp="23aucv0sfyoc1" />
        {/* Opportunity Section - Centered */}
        <section className="py-12 md:py-20 bg-white" data-id="element-239" data-mp="1z9inmwdhc54d">
          <div className="container mx-auto px-4 md:px-12" data-id="element-240" data-mp="1u9e3mwdd4s9e">
            <div className="max-w-4xl mx-auto text-center" data-id="element-241" data-mp="1kkqnlgkg8gf0">
              <h2 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-6" data-id="element-242" data-mp="1kj5uzwhp37js">
                Our belief
              </h2>
              <div className="space-y-4" data-id="element-243" data-mp="1amjbbb13umjc">
                <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-244" data-mp="1anun9y4pf0lj">
                  Progress requires two things: something to believe in, and
                  believers empowered to express it - or purpose and people. We
                  believe you can't successfully move one without the other. We
                  also believe the key to "how" is hidden in the siloed
                  conversations unfolding across your company.
                </p>
                <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-245" data-mp="1yjqaojsbcn92">
                  We help business leaders surface the ideas buried in those
                  conversations to answer two basic questions: what do you want
                  to be known for? And what do you need to change for the world
                  to realize it?
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Home Image 2 - Centered, smaller */}
        <section className="py-8 md:py-12 bg-white" data-id="element-246" data-mp="oedv1o2a3gv9">
          <div className="container mx-auto px-4 md:px-12" data-id="element-247" data-mp="ofyo198y2rr0">
            <div className="max-w-[170px] mx-auto" data-id="element-248" data-mp="kdtxijdsmb8l">
              <div className="w-full aspect-square overflow-hidden rounded-lg" data-id="element-249" data-mp="3ssccl525ir1p">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8JnCnwFgpu5hq3nksuUQDp/Home_Image_2.png" alt="Abstract geometric pattern" className="w-full h-full object-cover" style={{
                transform: `rotate(${rotation}deg)`,
                transition: 'transform 0.1s linear'
              }} data-id="element-250" data-mp="3sugexikejhzv" />
              </div>
            </div>
          </div>
        </section>
        {/* Offering Section - Centered headline and intro */}
        <section className="py-12 md:py-20 bg-white" data-id="element-251" data-mp="27ey93uppdvxj">
          <div className="container mx-auto px-4 md:px-12" data-id="element-252" data-mp="27g9chtf8l1o4">
            <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16" data-id="element-253" data-mp="2cdret0yr0in5">
              <h2 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-6" data-id="element-254" data-mp="2hbt3q2iuvc6j">
                People Effectiveness Partner
              </h2>
              <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-255" data-mp="2m8t1lq5jx8mk">
                People don't get more effective by accident. Real progress takes
                perspective, purpose, principles, and practice, so every change
                lands where the work happens. That's where we focus.
              </p>
            </div>
            {/* Offering Grid - Alternating images and content */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-256" data-mp="3a104771vebuf">
              {/* Row 1: Home Image 3 | Offering 1 (Perspective) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-257" data-mp="3e2v17zcrq32e">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3oR6H9tZVB11XzvwiegNoV/Home_image_3.jpg" alt="Modern architectural staircase detail" className="w-full h-full object-cover" data-id="element-258" data-mp="12f8b60sa82at" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-259" data-mp="ofqnjoqq2v31">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-260" data-mp="1m38r8l5j1706">
                  Perspective
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-261" data-mp="1h4nzla4cbvnc">
                  What to fix, where it counts.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-262" data-mp="17el0cs6mllgk">
                  Your people are telling you what's helping, and what's holding
                  them back. Huwey (our AI platform) translates their
                  unstructured feedback into answers, showing you the
                  perceptions, drivers, and priorities that unlock performance.
                </p>
                <Link to="/perspective" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-263" data-mp="271lg9z4kgvn">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-264" data-mp="3pi1abig0y397">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-265" data-mp="31mylvbl4u1t9" />
                  </svg>
                </Link>
              </div>
              {/* Row 2: Home Image 4 | Offering 2 (Purpose) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-266" data-mp="1eyd5vof47hi6">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hEeLcCWariX9pD9e9ZS4Lt/Home_Image_4.jpg" alt="Macro nature pattern with green organic texture" className="w-full h-full object-cover" data-id="element-267" data-mp="19z0in2kc08f2" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-268" data-mp="1xnjqxi3dsl75">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-269" data-mp="1sphzo9vsxfkl">
                  Purpose
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-270" data-mp="26o7xxsucxlaj">
                  Say less. Mean more.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-271" data-mp="caqd4dlc72j7">
                  What you stand for should be obvious—not just to marketing,
                  but to every team, partner, and customer. Our Positioning
                  Services help you define a point of view big enough to move
                  markets and practical enough to scale across the business.
                </p>
                <Link to="/purpose" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-272" data-mp="16jcwk737q6ux">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-273" data-mp="dwin057xorw8">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-274" data-mp="rvi4msx146iw" />
                  </svg>
                </Link>
              </div>
              {/* Row 3: Home Image 5 | Offering 3 (Principles) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-275" data-mp="28epq23aktwn2">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/avrgvoGdP4i3rEbEjzCB3x/Home_Image_5.jpg" alt="Abstract layered pattern with teal and sand tones" className="w-full h-full object-cover" data-id="element-276" data-mp="23o0w8hbfcnkr" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-277" data-mp="1porehd7klleo">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-278" data-mp="1kp50v2nty35c">
                  Principles
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-279" data-mp="1gpe48ibmgssw">
                  Change the experience. Transform the business.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-280" data-mp="3b1ay0hxjear4">
                  Plans don't drive progress. People do. Our Transformation
                  Services help you turn strategy into momentum by shifting
                  behaviors, building habits, and empowering leaders to carry
                  transformation into everyday moments.
                </p>
                <Link to="/principles" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-281" data-mp="hn69cnkyo36w">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-282" data-mp="3l5ppirqd7ilc">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-283" data-mp="37cgp3gkea7ey" />
                  </svg>
                </Link>
              </div>
              {/* Row 4: Home Image 6 | Offering 4 (Practice) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-284" data-mp="18vzfgswa5jnm">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tFrGaPzxNA4UjBnPUeK3jf/Home_Image_6.jpg" alt="Geometric green brick pattern" className="w-full h-full object-cover" data-id="element-285" data-mp="1cwi8urdtmxrx" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-286" data-mp="25j307ruar9vh">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-287" data-mp="1ro0j08k01y3d">
                  Practice
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-288" data-mp="g696ey9i97yd">
                  Move people, not just plans.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-289" data-mp="l3ivudww9jm7">
                  Training explains change. Experiences create it. Our Immersive
                  Experiences strip away hierarchy, simulate real dynamics, and
                  connect new ways of working directly to the places where
                  progress happens.
                </p>
                <Link to="/practice" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-290" data-mp="292v0mho63tam">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-291" data-mp="1z7jidpdjw3y4">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-292" data-mp="3ojbzyb5lbdbx" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Client Banner */}
        <ClientLogos data-id="element-293" data-mp="1g2xzsz5tocmh" />
        {/* About CTA Section */}
        <section className="py-12 md:py-20 bg-white" data-id="element-294" data-mp="1k0vom0vokwpc">
          <div className="container mx-auto px-4 md:px-12" data-id="element-295" data-mp="nbwhip6u20yq">
            <div className="max-w-4xl mx-auto text-center" data-id="element-296" data-mp="ndhd8i4vvpy6">
              <p className="font-inter text-base md:text-lg leading-relaxed text-black mb-4" data-id="element-297" data-mp="sa7p0t9nnzds">
                What do a game designer, a product marketer, and a business exec
                have in common?
              </p>
              <p className="font-inter text-base md:text-lg leading-relaxed text-black mb-6" data-id="element-298" data-mp="11cgxzep9zkp2">
                Turns out, a lot more than we realized.
              </p>
              <Link to="/about" className="inline-flex items-center font-poppins font-normal text-base md:text-lg text-black hover:text-lime transition-colors" data-id="element-299" data-mp="2cqba5kkz27zi">
                Meet the team
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2" data-id="element-300" data-mp="26c5hn9m1g6fp">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-301" data-mp="2u801aq6m83le" />
                </svg>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-302" data-mp="2z1cnktntnyaz" />
    </div>;
}